export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13612.f8109381.jpg";